<template>
  <ls-table-layout>
    <div ref="charts" class="table-page-search-wrapper" slot="search">
      <!-- 供应商当天负荷-->
      <supplierDailyChart ref="refSupplierDailyChart"></supplierDailyChart>
      <!-- 产线产能负荷-->
      <!-- <productionLineCapacityChart></productionLineCapacityChart> -->
    </div>
    <div ref="tableTitle" class="table-page-operator-wrapper" slot="btn">
      <!-- <a-button @click="$refs.createModal.show()" type="primary" v-hasPermi="['scp:scpApsAbnormality:add']">新建</a-button>
      <a-button @click="importExcelHandleOpen" type="primary" v-hasPermi="['scp:scpApsAbnormality:import']">导入</a-button>
      <a-button @click="handleExport" v-hasPermi="['scp:scpApsAbnormality:export']">导出</a-button>
      <a-button @click="importTemplate" v-hasPermi="['scp:scpApsAbnormality:template']">下载模板</a-button> -->
      <a-row type="flex" justify="space-around" align="middle">
        <a-col class="w17-pc">
          <span>工序产能负荷</span>
        </a-col>
        <a-col class="w10-pc">
          <span>排产日期日期范围</span>
        </a-col>
        <a-col class="w20-pc">
          <a-range-picker v-model="queryParams.dateRange" @change="onDateRangeChange" />
        </a-col>
        <a-col class="w7-pc">
          <span class="pl28">供应商</span>
        </a-col>
        <a-col class="w46-pc">
          <global-select
            v-model="queryParams.vendorCode"
            v-decorator="[
              'vendorCode',
              { rules: [{ required: true, message: '请选择供应商' }] }
            ]"
            @change="handleVendorChange"
            :dropdown-match-select-width="false"
            requestApi="/scp/scpProductionScheduling/listPcSupplier"
            :selectItem="{ value: 'realValue', label: 'label' }"
          />
        </a-col>
      </a-row></div>
    <template v-slot:table>
      <div class="w100-pc">
        <productLineCapacityTable :table-data="tableData" :table-columns="tableColumns" :cusHeight="schedulingInfoTableHeight">
        </productLineCapacityTable>
      </div>

    </template>
  </ls-table-layout>

</template>
<script>
import { operationCnSearch } from "@/api/scp/productionScheduling/schedulingWorkbench.js"
import productionLineCapacityChart from './components/productionLineCapacityChart.vue';
import supplierDailyChart from './components/supplierDailyChart.vue';
import productLineCapacityTable from './components/productLineCapacityTable.vue';
import * as lodash from 'lodash'
import moment from 'moment'

export default {
  // eslint-disable-next-line
  name: 'productionProcessesLoad',
  components: {
    supplierDailyChart,
    productionLineCapacityChart,
    productLineCapacityTable
  },
  data () {
    return {
      schedulingInfoTableHeight: 0,
      queryParams: {
        vendorCode: '',
        startDate: '',
        endDate: '',
        dateRange: []
      },
      // 表格字段
      columns: [
        {
          title: '异常发现日期',
          dataIndex: 'abnormalityDiscoveredDate',
          scopedSlots: { customRender: 'abnormalityDiscoveredDate' },
          width: 150,
          align: 'center',
          type: "date"
        },
        {
          title: '加工组织',
          dataIndex: 'organizationCode',
          scopedSlots: { customRender: 'organizationCode' },
          width: 170,
          align: 'center',
          type: "select",
          selectType: "selectAssemble",
          assembleLabel: true,
          dataList: 'inventOrg',
          value: 'realValue',
          label: 'label'
        },
        {
          title: '供应商',
          width: 170,
          dataIndex: 'supplierName',
          align: 'center'
        },
        {
          title: '车间编码',
          dataIndex: 'workshopCode',
          scopedSlots: { customRender: 'workshopCode' },
          width: 170,
          align: 'center',
          type: "select",
          dataList: 'workshopCodeListNew',
          value: 'workshopCode',
          label: 'workshopDesc'
        },
        {
          title: '车间说明',
          width: 120,
          dataIndex: 'workshopDesc',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '产线编码',
          dataIndex: 'prodLineCode',
          scopedSlots: { customRender: 'prodLineCode' },
          width: 170,
          align: 'center',
          type: "select",
          dataList: 'prodLineCodeListNew',
          value: 'prodLineCode',
          label: 'prodLineDesc'
        },
        {
          title: '产线说明',
          dataIndex: 'prodLineDesc',
          width: 120,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '班组长',
          dataIndex: 'monitor',
          width: 120,
          scopedSlots: { customRender: 'monitor' },
          align: 'center',
          type: "input"
        },
        {
          title: '产品型号',
          dataIndex: 'itemCode',
          scopedSlots: { customRender: 'itemCode' },
          width: 170,
          align: 'center',
          type: "select",
          selectType: "selectAssembleSearch",
          requestApi: "/mes/mesDiscreteJobs/assemblyBox",
          searchParam: "itemCode",
          value: 'selectedValue',
          label: 'bringOutDataOne'
        },
        {
          title: '规格描述',
          width: 120,
          dataIndex: 'specification',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '生产工单',
          dataIndex: 'job',
          scopedSlots: { customRender: 'job' },
          width: 170,
          align: 'center',
          type: "select",
          dataList: 'jobList',
          value: 'realValue',
          label: 'label'
        },
        {
          title: '异常类型',
          dataIndex: 'abnormalType',
          scopedSlots: { customRender: 'abnormalType' },
          width: 170,
          align: 'center',
          type: "select",
          dataList: 'abnormalTypeList',
          value: 'lookupCode',
          label: 'lookupValue'
        },
        {
          title: '异常原因说明',
          dataIndex: 'abnormalReason',
          scopedSlots: { customRender: 'abnormalReason' },
          width: 170,
          align: 'center',
          type: "input"
        },
        {
          title: '责任归属',
          width: 120,
          dataIndex: 'liability',
          scopedSlots: { customRender: 'liability' },
          align: 'center',
          type: "input"
        },
        {
          title: '影响数量(套)',
          width: 120,
          dataIndex: 'affectedQty',
          scopedSlots: { customRender: 'affectedQty' },
          align: 'center',
          type: "inputNumber"
        },
        {
          title: '影响工时(时)',
          width: 120,
          dataIndex: 'affectedWorkingHours',
          scopedSlots: { customRender: 'affectedWorkingHours' },
          align: 'center',
          type: "inputNumber"
        },
        {
          title: '相关配合事项',
          width: 120,
          dataIndex: 'relatedCoordinatedMatter',
          scopedSlots: { customRender: 'relatedCoordinatedMatter' },
          align: 'center',
          type: "input"
        },
        {
          title: '通知PMC',
          dataIndex: 'pmcInformedFlag',
          scopedSlots: { customRender: 'pmcInformedFlag' },
          width: 170,
          align: 'center',
          type: "select",
          dataList: 'pmcInformedFlagList',
          value: 'lookupCode',
          label: 'lookupValue'
        },
        {
          title: '最后修改人',
          width: 120,
          dataIndex: 'updateName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '最后修改时间',
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
          width: 160,
          align: 'center',
          type: "text"
        },
        {
          title: '创建人',
          width: 120,
          dataIndex: 'createName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: 160,
          align: 'center',
          type: "text"
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right'
        }
      ],
      tableData: [],
      tableColumns: []
    }
  },
  methods: {
    updateBrowserHeight () {
            //  <!-- 浏览器高度-->
            const browserHeight = window.innerHeight;
      console.log("browserHeight", browserHeight);
      // toolBar 的高度
      const chartsHeight = this.$refs.charts.clientHeight;
      console.log("toolBarHeight", chartsHeight);
      // 拖拽表格的高度
      const tableTitleHeight = this.$refs.tableTitle.clientHeight;
      console.log("tableTitleHeight", tableTitleHeight);
      // 数据表格高度
      this.schedulingInfoTableHeight =
        browserHeight - chartsHeight - tableTitleHeight - 210;
      console.log("TableHeight", this.schedulingInfoTableHeight);
    },
    handleDynamicHeight: lodash.throttle(function () {
      this.updateBrowserHeight()
      // 在这里处理动态组件高度的变化
      // 可以使用 this.dynamicHeight 获取当前的高度值
      // 执行节流函数后，该函数将在一定时间间隔内最多被调用一次
    }, 100), // 设置节流函数的时间间隔为 200 毫秒
    handleVendorChange (val) {
      this.queryParams.vendorCode = val
      if (this.queryParams.startDate && this.queryParams.endDate) {
        this.initData()
      }
    },
    onDateRangeChange (val) {
      this.queryParams.startDate = val[0].format('YYYY-MM-DD')
      this.queryParams.endDate = val[1].format('YYYY-MM-DD')
      if (this.queryParams.vendorCode) {
        this.initData()
      }
    },
    initData () {
      operationCnSearch({
        startDate: this.queryParams.startDate,
        endDate: this.queryParams.endDate,
        vendorCode: this.queryParams.vendorCode
      }).then(res => {
        // 使用 Set 来存储唯一的 startDate
        const uniqueDatesSet = new Set(res.map(item => item.startDate));
        // 将 Set 转换为数组
        const uniqueDatesArray = [...uniqueDatesSet];
        console.log(uniqueDatesArray)
        const tempColumns = [
          {
            slots: { title: 'headerName' },
            dataIndex: 'operationDesc',
            key: 'operationDesc',
            width: 144
          }
        ]
        uniqueDatesArray.forEach(item => {
          tempColumns.push({
            title: item,
            dataIndex: item
          })
        })
        this.tableData = this.generateNewArray(res)
        this.tableColumns = tempColumns
      })
    },
    generateNewArray (data) {
      return data.reduce((result, item) => {
        const { startDate, operationDesc, procedureLoad } = item;
        // 查找数组中是否已存在该 operationDesc
        const existingItem = result.find(entry => entry.operationDesc === operationDesc);
        if (!existingItem) {
          // 如果不存在，创建新的项
          const newItem = {
            operationDesc: operationDesc,
            [startDate]: `${parseFloat((procedureLoad * 100).toFixed(2))}%`
          };
          result.push(newItem);
        } else {
          // 如果已存在，添加新的日期和 procedureLoad
          existingItem[startDate] = `${parseFloat((procedureLoad * 100).toFixed(2))}%`;
        }
        return result;
      }, []);
    }
  },
  mounted () {
    this.updateBrowserHeight(); // 初始化时更新一次高度
    window.addEventListener("resize", this.handleDynamicHeight);
    const routeParamsArr = this.$route.params.id.split('&')
    // 获取当天日期
    const todayDate = moment();
    // 往后推7天的日期
    const nextWeekDate = moment().add(7, 'days');

    if (routeParamsArr[1] !== 'undefined') {
      this.queryParams.startDate = routeParamsArr[1] // 开始时间
    } else {
      this.queryParams.startDate = todayDate.format('YYYY-MM-DD') // 开始时间
    }
    if (routeParamsArr[2] !== 'undefined') {
      this.queryParams.endDate = routeParamsArr[2] // 结束时间
    } else {
      this.queryParams.endDate = nextWeekDate.format('YYYY-MM-DD') // 结束时间
    }
    this.queryParams.dateRange = [
      moment(this.queryParams.startDate),
      moment(this.queryParams.endDate)
    ]

    if (routeParamsArr[0] !== 'undefined') {
      this.queryParams.vendorCode = routeParamsArr[0] // 供应商编码
      this.initData()
      this.$refs.refSupplierDailyChart.setQueryParamsAndQuery(this.queryParams.vendorCode, this.queryParams.startDate, this.queryParams.endDate)
    } else {
      this.$refs.refSupplierDailyChart.setQueryParamsAndQuery(null, this.queryParams.startDate, this.queryParams.endDate)
    }
  },
  beforeDestroy () {
    window.removeEventListener("resize", this.handleDynamicHeight);
  }
}
</script>
<style lang="less"  scoped>
/deep/.ant-select{
  width: 150px;
}
.w17-pc {
  width: 17%;
}
.w10-pc {
  width: 10%;
}
.w20-pc {
  width: 20%;
}
.w7-pc {
  width: 7%;
}
.w46-pc {
  width: 46%;
}
.pl28 {
  padding-left: 28px;
}
</style>
